// theme
import palette from '../theme/palette';

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary,
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#7635dc',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#000000',
    gradient1: 'transparent',
    gradient2: 'transparent',
    gradient3: 'transparent',
    gradient4: 'transparent',
    gradient5: 'transparent',
    gradient6: 'transparent',
    gradientIOS1: 'transparent',
    gradientIOS2: 'transparent',
    gradientIOS3: 'transparent',
    gradientIOS4: 'transparent',
    gradientIOS5: 'transparent',
    gradientIOS6: 'transparent',
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800],
    gradient1: 'transparent',
    gradient2: 'transparent',
    gradient3: 'transparent',
    gradient4: 'transparent',
    gradient5: 'transparent',
    gradient6: 'transparent',
    gradientIOS1: 'transparent',
    gradientIOS2: 'transparent',
    gradientIOS3: 'transparent',
    gradientIOS4: 'transparent',
    gradientIOS5: 'transparent',
    gradientIOS6: 'transparent',
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#D1E9FC',
    light: '#76B0F1',
    main: '#2065D1',
    dark: '#103996',
    darker: '#061B64',
    contrastText: '#000000',
    gradient1: 'transparent',
    gradient2: 'transparent',
    gradient3: 'transparent',
    gradient4: 'transparent',
    gradient5: 'transparent',
    gradient6: 'transparent',
    gradientIOS1: 'transparent',
    gradientIOS2: 'transparent',
    gradientIOS3: 'transparent',
    gradientIOS4: 'transparent',
    gradientIOS5: 'transparent',
    gradientIOS6: 'transparent',
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.light.grey[800],
    gradient1: 'transparent',
    gradient2: 'transparent',
    gradient3: 'transparent',
    gradient4: 'transparent',
    gradient5: 'transparent',
    gradient6: 'transparent',
    gradientIOS1: 'transparent',
    gradientIOS2: 'transparent',
    gradientIOS3: 'transparent',
    gradientIOS4: 'transparent',
    gradientIOS5: 'transparent',
    gradientIOS6: 'transparent',
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff',
    gradient1: 'transparent',
    gradient2: 'transparent',
    gradient3: 'transparent',
    gradient4: 'transparent',
    gradient5: 'transparent',
    gradient6: 'transparent',
    gradientIOS1: 'transparent',
    gradientIOS2: 'transparent',
    gradientIOS3: 'transparent',
    gradientIOS4: 'transparent',
    gradientIOS5: 'transparent',
    gradientIOS6: 'transparent',
  },
  // YELLOW
  {
    name: 'yellow',
    lighter: '#FFFC8F',
    light: '#FFCC00',
    main: '#FFB200',
    dark: '#FF9322',
    darker: '#B26718',
    contrastText: '#000',
    lightText: '#20202080',
    darkText: '#555D74',
    gradient1: '#ffffff',
    gradient2: '#f7d94e',
    gradient3: '#f5d84a',
    gradient4: '#fdf5d0',
    gradient5: '#f5f4f2',
    gradient6: '#f2f1f0',
    gradientIOS1: 'rgb(255, 255, 255)',
    gradientIOS2: 'rgb(244, 221, 123)',
    gradientIOS3: 'rgb(241 215 107)',
    gradientIOS4: 'rgb(253, 245, 208)',
    gradientIOS5: 'rgb(245, 244, 242)',
    // gradientIOS6: 'rgb(242, 241, 240)',
    gradientIOS6: '#F6F7F9',
  },
  // GREEN
  {
    name: 'green',
    lighter: '#E6F9C8',
    light: '#ADDF55',
    main: '#7DC525',
    dark: '#4E9A00',
    darker: '#2A6500',
    contrastText: '#000',
    lightText: '#20202080',
    darkText: '#555D74',
    gradient1: '#ffffff',
    gradient2: '#f0fad8',
    gradient3: '#e6f9c8',
    gradient4: '#d9f5b0',
    gradient5: '#f0fad8',
    gradient6: '#f5fbee',
    gradientIOS1: 'rgb(255, 255, 255)',
    gradientIOS2: 'rgb(240, 250, 216)',
    gradientIOS3: 'rgb(230, 249, 200)',
    gradientIOS4: 'rgb(217, 245, 176)',
    gradientIOS5: 'rgb(240, 250, 216)',
    gradientIOS6: '#F6F7F9',
  }
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const cyanPreset = colorPresets[2];
export const bluePreset = colorPresets[3];
export const orangePreset = colorPresets[4];
export const redPreset = colorPresets[5];
export const yellowPreset = colorPresets[6];
export const greenPreset = colorPresets[7];

export default function getColorPresets(presetsKey) {
  return {
    purple: purplePreset,
    cyan: cyanPreset,
    blue: bluePreset,
    orange: orangePreset,
    red: redPreset,
    yellow: yellowPreset,
    green: greenPreset,
    default: defaultPreset,
  }[presetsKey];
}
